export default __webpack_public_path__ + "static/media/airplane.8ca788b6.svg";